import { render, staticRenderFns } from "./OuterFragmentTab.vue?vue&type=template&id=022c4b2a&scoped=true&"
import script from "./OuterFragmentTab.vue?vue&type=script&lang=js&"
export * from "./OuterFragmentTab.vue?vue&type=script&lang=js&"
import style0 from "./OuterFragmentTab.vue?vue&type=style&index=0&id=022c4b2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022c4b2a",
  null
  
)

export default component.exports